import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class OnlineCreditService extends BaseService {
  httpClient: HttpClient;

  constructor() {
    const httpClient = inject(HttpClient);

    super();
    this.httpClient = httpClient;

    this.path = '/online-credit';
  }

  generate(item: any): Observable<any> {
    return this.httpClient.post(`${this.getBaseUrl()}${this.path}`, item).pipe(
      map((result) => {
        return result;
      }),
    );
  }

  findById(id): Observable<any> {
    return this.httpClient.get(`${this.getBaseUrl()}${this.path}/${id}`).pipe(
      map((onlineCredit) => {
        return onlineCredit;
      }),
    );
  }

  cancelCredit(id) {
    return this.httpClient.put(`${this.getBaseUrl()}${this.path}/${id}/cancel`, {}).pipe(
      map((result) => {
        return result;
      }),
    );
  }
}
